import { useEffect } from "react";
import useLenis from "@/lib/useLenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import USPBanner from "@/components/USPBanner";
import NeedCheck from "@/components/NeedCheck";
import Tiers from "@/components/Tiers";
import DecisionTree from "@/components/DecisionTree";
import HowItWorks from "@/components/HowItWorks";
import WhatWeNegotiate from "@/components/WhatWeNegotiate";
import CaseStudies from "@/components/CaseStudies";
import Calculator from "@/components/Calculator";
import Problem from "@/components/Problem";
import Promise from "@/components/Promise";
import WhyNotDIY from "@/components/WhyNotDIY";
import WhenToUse from "@/components/WhenToUse";
import PDIToolkit from "@/components/PDIToolkit";
import LeadMagnet from "@/components/LeadMagnet";
import ConsultationForm from "@/components/ConsultationForm";
import Testimonials from "@/components/Testimonials";
import Founder from "@/components/Founder";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import StickyWhatsApp from "@/components/StickyWhatsApp";
import DiscoveryCallFloat from "@/components/DiscoveryCallFloat";

export default function Home() {
  useLenis();

  // If we arrived here via a cross-page section link (e.g. /#tiers from
  // another page), scroll to that section once this page has mounted.
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash;
      const t = setTimeout(() => {
        const el = document.querySelector(id);
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" });
      }, 120);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <main className="relative bg-void text-silver" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <USPBanner />
      <NeedCheck />
      <Tiers />
      <DecisionTree />
      <HowItWorks />
      <WhatWeNegotiate />
      <CaseStudies />
      <Calculator />
      <Problem />
      <Promise />
      <WhyNotDIY />
      <WhenToUse />
      <PDIToolkit />
      <LeadMagnet />
      <ConsultationForm />
      <Testimonials />
      <Founder />
      <FAQ />
      <FinalCTA />
      <Footer />
      <StickyWhatsApp />
      <DiscoveryCallFloat />
    </main>
  );
}
